export default {"src":"/_next/static/media/blob.6a272e21.svg","height":500,"width":500};